import type {
	JSX,
} from 'react'
import {
	useEffect,
	useRef,
} from 'react'

import {
	useTelegramUser,
} from '@/shared/lib/hooks'

import {
	userService,
} from '@/modules/user'

import {
	useAuthStore,
} from '../../lib/stores'
import type {
	IAuthTelegramInitializerProps,
} from './auth-telegram-initializer.types'

export const AuthTelegramInitializer = (props: IAuthTelegramInitializerProps): JSX.Element => {
	const {
		children,
	} = props

	const {
		user: telegramUser,
	} = useTelegramUser()

	const {
		user,
		initializing,
		setUser,
		finishInitializing,
		logout,
	} = useAuthStore()

	const isInitializedRef = useRef(false)

	useEffect(() => {
		if (isInitializedRef.current) {
			return
		}

		const initializeAuth = async(): Promise<void> => {
			if (!telegramUser) {
				finishInitializing()
				isInitializedRef.current = true

				return
			}

			try {
				const appUser = await userService.getOrCreate({
					id:         telegramUser.id,
					first_name: telegramUser.first_name,
					last_name:  telegramUser.last_name,
					username:   telegramUser.username,
					photo_url:  telegramUser.photo_url,
				})

				const verifiedUser = await userService.getMe()

				if (verifiedUser) {
					setUser(verifiedUser)
				}
				else {
					setUser(appUser)
				}
			}
			// eslint-disable-next-line
			catch(error) {
				logout()
			}
			finally {
				finishInitializing()
				isInitializedRef.current = true
			}
		}

		initializeAuth()
	}, [telegramUser, user, setUser, finishInitializing, logout])

	// todo: Set Here Fallback
	if (initializing) {
		return <div>Loading...</div>
	}

	return (
		<>
			{children}
		</>
	)
}
